export default "__VITE_ASSET__CCGJxK_F__"